import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../../Resolve';
import * as roles from '../../../common/Roles';

const states: Ng1StateDeclaration[] = [
    {
        name: 'applications.overview',
        url: '/overview',
        component: 'wtApplicationsOverview',
        resolve: {
            auth: Resolve.authResolve,
            roles: Resolve.rolesResolve([roles.superAdministrator, roles.administrator, roles.master, roles.engineer])
        },
        data: {
            visible: false,
            sortingOrder: 200,
            icon: 'fa-clock-o',
            displayName: 'Applications overview',
            editRoles: [roles.administrator, roles.engineer],
            editButtonVisibility: () => false
        }
    }];

export default states;